import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { configuracionAPI, uploadAPI, facturacionAPI, getImageUrl } from '../services/api';
import { useApp } from '../context/AppContext';

const AI_MODELS = [
  { value: 'openai/gpt-4o-mini', label: 'GPT-4o Mini (Rápido y económico)', provider: 'OpenAI' },
  { value: 'openai/gpt-4o', label: 'GPT-4o (Mejor calidad)', provider: 'OpenAI' },
  { value: 'openai/gpt-3.5-turbo', label: 'GPT-3.5 Turbo', provider: 'OpenAI' },
  { value: 'anthropic/claude-3-haiku', label: 'Claude 3 Haiku (Rápido)', provider: 'Anthropic' },
  { value: 'anthropic/claude-3.5-sonnet', label: 'Claude 3.5 Sonnet (Recomendado)', provider: 'Anthropic' },
  { value: 'google/gemini-pro', label: 'Gemini Pro', provider: 'Google' },
  { value: 'google/gemini-pro-1.5', label: 'Gemini 1.5 Pro', provider: 'Google' },
  { value: 'meta-llama/llama-3-70b-instruct', label: 'Llama 3 70B', provider: 'Meta' },
  { value: 'mistralai/mistral-7b-instruct', label: 'Mistral 7B (Gratis)', provider: 'Mistral' }
];

const Configuracion = () => {
  const { config, setConfig } = useApp();
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [testingAI, setTestingAI] = useState(false);
  const [activeTab, setActiveTab] = useState('general');
  const [formData, setFormData] = useState({});
  // SRI
  const [sriUploading, setSriUploading] = useState(false);
  const [sriTesting, setSriTesting] = useState(false);
  const [certificadoInfo, setCertificadoInfo] = useState(null);
  const [certPassword, setCertPassword] = useState('');
  const [updatingPassword, setUpdatingPassword] = useState(false);

  useEffect(() => {
    setFormData({
      nombre_sistema: config.nombre_sistema || 'Óptica Inventario',
      logo_url: config.logo_url || '',
      empresa_nombre: config.empresa_nombre || '',
      empresa_ruc: config.empresa_ruc || '',
      empresa_direccion: config.empresa_direccion || '',
      empresa_telefono: config.empresa_telefono || '',
      empresa_email: config.empresa_email || '',
      iva_defecto: config.iva_defecto || 15,
      moneda: config.moneda || 'USD',
      simbolo_moneda: config.simbolo_moneda || '$',
      ai_enabled: config.ai_enabled === 'true' || config.ai_enabled === true,
      ai_api_key: config.ai_api_key || '',
      ai_model: config.ai_model || 'openai/gpt-4o-mini',
      // SRI
      sri_ambiente: config.sri_ambiente || '1',
      sri_tipo_emision: config.sri_tipo_emision || '1',
      sri_obligado_contabilidad: config.sri_obligado_contabilidad || 'NO',
      sri_contribuyente_especial: config.sri_contribuyente_especial || '',
      sri_agente_retencion: config.sri_agente_retencion || '',
      sri_regimen: config.sri_regimen || 'GENERAL',
      sri_direccion_matriz: config.sri_direccion_matriz || '',
      sri_nombre_comercial: config.sri_nombre_comercial || '',
      sri_auto_facturar: config.sri_auto_facturar === 'true' || config.sri_auto_facturar === true,
      sri_enviar_email_auto: config.sri_enviar_email_auto === 'true' || config.sri_enviar_email_auto === true,
      // SMTP Email
      smtp_host: config.smtp_host || '',
      smtp_port: config.smtp_port || '587',
      smtp_user: config.smtp_user || '',
      smtp_password: config.smtp_password || '',
      smtp_from: config.smtp_from || '',
      smtp_secure: config.smtp_secure || 'false',
      // Pagos - Payphone
      payphone_enabled: config.payphone_enabled === 'true' || config.payphone_enabled === true,
      payphone_token: config.payphone_token || '',
      payphone_store_id: config.payphone_store_id || '',
      payphone_ambiente: config.payphone_ambiente || 'test',
      payphone_response_url: config.payphone_response_url || `${window.location.origin}/payphone-callback`,
      // Pagos - Medianet
      medianet_enabled: config.medianet_enabled === 'true' || config.medianet_enabled === true,
      medianet_terminal_id: config.medianet_terminal_id || '',
      medianet_codigo_comercio: config.medianet_codigo_comercio || '',
      medianet_nombre_comercio: config.medianet_nombre_comercio || '',
      // Pagos - Comisiones
      comision_payphone: config.comision_payphone || '0',
      comision_medianet: config.comision_medianet || '0',
      comision_transferencia: config.comision_transferencia || '0',
      // Pagos - Credito
      credito_plazo_max: config.credito_plazo_max || '90',
      credito_requiere_aprobacion: config.credito_requiere_aprobacion === 'true' || config.credito_requiere_aprobacion === true,
      // Tickets
      ticket_nombre_negocio: config.ticket_nombre_negocio || '',
      ticket_direccion: config.ticket_direccion || '',
      ticket_telefono: config.ticket_telefono || '',
      ticket_ruc: config.ticket_ruc || '',
      ticket_mensaje_pie: config.ticket_mensaje_pie || 'Gracias por su compra!',
      ticket_auto_print: config.ticket_auto_print === 'true' || config.ticket_auto_print === true,
      ticket_mostrar_iva: config.ticket_mostrar_iva === 'true' || config.ticket_mostrar_iva === true || !config.ticket_mostrar_iva,
      ticket_mostrar_cliente: config.ticket_mostrar_cliente === 'true' || config.ticket_mostrar_cliente === true || !config.ticket_mostrar_cliente,
      ticket_mostrar_logo: config.ticket_mostrar_logo === 'true' || config.ticket_mostrar_logo === true || !config.ticket_mostrar_logo,
      ticket_logo_ancho: config.ticket_logo_ancho || '120'
    });
    // Cargar info certificado
    cargarCertificadoInfo();
  }, [config]);

  const cargarCertificadoInfo = async () => {
    try {
      const res = await facturacionAPI.getCertificadoInfo();
      if (res.data.success) setCertificadoInfo(res.data.data);
    } catch { setCertificadoInfo(null); }
  };

  const handleCertUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.name.endsWith('.p12') && !file.name.endsWith('.pfx')) {
      toast.error('Solo archivos .p12 o .pfx');
      return;
    }
    if (!certPassword) {
      toast.error('Ingrese primero la contraseña del certificado en el campo "1. Contraseña"');
      e.target.value = '';
      return;
    }
    setSriUploading(true);
    try {
      const res = await facturacionAPI.uploadCertificado(file, certPassword);
      if (res.data.success) {
        toast.success('Certificado subido correctamente');
        setCertificadoInfo(res.data.data?.certificado || res.data.data);
        setCertPassword('');
        e.target.value = '';
      }
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al subir certificado');
    } finally {
      setSriUploading(false);
    }
  };

  const handleUpdateCertPassword = async () => {
    if (!certPassword) {
      toast.error('Ingrese la nueva contraseña');
      return;
    }
    setUpdatingPassword(true);
    try {
      const res = await facturacionAPI.updateCertPassword(certPassword);
      if (res.data.success) {
        toast.success('Contraseña del certificado actualizada');
        setCertPassword('');
      }
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al actualizar contraseña');
    } finally {
      setUpdatingPassword(false);
    }
  };

  const testConexionSRI = async () => {
    setSriTesting(true);
    try {
      const res = await facturacionAPI.testConexion();
      if (res.data.success) {
        toast.success('Conexion exitosa con el SRI');
      } else {
        toast.error(res.data.error || 'Error de conexion');
      }
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error al conectar con el SRI');
    } finally {
      setSriTesting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { toast.error('Solo imágenes'); return; }
    if (file.size > 2 * 1024 * 1024) { toast.error('Máximo 2MB'); return; }

    setUploading(true);
    try {
      const res = await uploadAPI.upload(file);
      if (res.data.success) {
        const logoUrl = res.data.data.url;
        setFormData(prev => ({ ...prev, logo_url: logoUrl }));
        await configuracionAPI.update('logo_url', logoUrl);
        setConfig(prev => ({ ...prev, logo_url: logoUrl }));
        toast.success('Logo actualizado');
      }
    } catch (e) { toast.error('Error al subir'); }
    finally { setUploading(false); }
  };

  const removeLogo = async () => {
    if (!window.confirm('¿Eliminar logo?')) return;
    try {
      await configuracionAPI.update('logo_url', '');
      setFormData(prev => ({ ...prev, logo_url: '' }));
      setConfig(prev => ({ ...prev, logo_url: '' }));
      toast.success('Logo eliminado');
    } catch (e) { toast.error('Error'); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const dataToSave = {
        ...formData,
        ai_enabled: formData.ai_enabled ? 'true' : 'false',
        sri_auto_facturar: formData.sri_auto_facturar ? 'true' : 'false',
        sri_enviar_email_auto: formData.sri_enviar_email_auto ? 'true' : 'false',
        payphone_enabled: formData.payphone_enabled ? 'true' : 'false',
        medianet_enabled: formData.medianet_enabled ? 'true' : 'false',
        credito_requiere_aprobacion: formData.credito_requiere_aprobacion ? 'true' : 'false',
        ticket_auto_print: formData.ticket_auto_print ? 'true' : 'false',
        ticket_mostrar_iva: formData.ticket_mostrar_iva ? 'true' : 'false',
        ticket_mostrar_cliente: formData.ticket_mostrar_cliente ? 'true' : 'false'
      };
      await configuracionAPI.updateBulk(dataToSave);
      setConfig(prev => ({ ...prev, ...formData }));
      toast.success('Configuracion guardada');
    } catch (e) { toast.error('Error al guardar'); }
    finally { setLoading(false); }
  };

  const testAIConnection = async () => {
    if (!formData.ai_api_key) { toast.error('Ingrese una API Key'); return; }
    setTestingAI(true);
    try {
      const response = await fetch('https://openrouter.ai/api/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${formData.ai_api_key}`,
          'HTTP-Referer': window.location.origin
        },
        body: JSON.stringify({
          model: formData.ai_model,
          messages: [{ role: 'user', content: 'Responde solo: OK' }],
          max_tokens: 10
        })
      });
      const data = await response.json();
      if (data.choices) { toast.success('✅ Conexión exitosa con IA'); }
      else { toast.error('Error: ' + (data.error?.message || 'Sin respuesta')); }
    } catch (e) { toast.error('Error de conexión: ' + e.message); }
    finally { setTestingAI(false); }
  };

  const logoUrl = getImageUrl(formData.logo_url);

  const tabs = [
    { id: 'general', icon: 'bi-gear', label: 'General' },
    { id: 'branding', icon: 'bi-palette', label: 'Branding' },
    { id: 'empresa', icon: 'bi-building', label: 'Empresa' },
    { id: 'sri', icon: 'bi-file-earmark-check', label: 'SRI / Facturacion' },
    { id: 'pagos', icon: 'bi-credit-card', label: 'Pagos' },
    { id: 'ia', icon: 'bi-robot', label: 'Inteligencia Artificial' }
  ];

  return (
    <div>
      {/* Tabs */}
      <ul className="nav nav-tabs mb-4">
        {tabs.map(tab => (
          <li className="nav-item" key={tab.id}>
            <button 
              className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={`bi ${tab.icon} me-2`}></i>{tab.label}
            </button>
          </li>
        ))}
      </ul>

      <form onSubmit={handleSubmit}>
        {/* General */}
        {activeTab === 'general' && (
          <div className="card fade-in">
            <div className="card-header"><i className="bi bi-gear me-2"></i>Configuración General</div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Nombre del Sistema</label>
                  <input type="text" className="form-control" name="nombre_sistema" value={formData.nombre_sistema || ''} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">IVA por Defecto (%)</label>
                  <input type="number" step="0.01" className="form-control" name="iva_defecto" value={formData.iva_defecto || ''} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Moneda</label>
                  <select className="form-select" name="moneda" value={formData.moneda || ''} onChange={handleChange}>
                    <option value="USD">Dólar (USD)</option>
                    <option value="EUR">Euro (EUR)</option>
                    <option value="MXN">Peso Mexicano (MXN)</option>
                    <option value="COP">Peso Colombiano (COP)</option>
                    <option value="PEN">Sol Peruano (PEN)</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Símbolo</label>
                  <input type="text" className="form-control" name="simbolo_moneda" value={formData.simbolo_moneda || ''} onChange={handleChange} maxLength="5" />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Branding */}
        {activeTab === 'branding' && (
          <div className="card fade-in">
            <div className="card-header"><i className="bi bi-palette me-2"></i>Branding / Logotipo</div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">Logotipo del Sistema</label>
                  <p className="text-muted small">Tamaño recomendado: 200x200px. Máximo 2MB.</p>
                  <div className="mb-3">
                    <input type="file" className="form-control" accept="image/*" onChange={handleLogoUpload} disabled={uploading} />
                  </div>
                  {uploading && <div className="text-primary mb-2"><span className="spinner-border spinner-border-sm me-2"></span>Subiendo...</div>}
                  {formData.logo_url && (
                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={removeLogo}>
                      <i className="bi bi-trash me-1"></i>Eliminar Logo
                    </button>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Vista Previa</label>
                  <div className="p-4 rounded text-center" style={{ background: 'linear-gradient(135deg, #5a89b3 0%, #4a7a9e 100%)' }}>
                    {logoUrl ? (
                      <img src={logoUrl} alt="Logo" className="config-logo-preview" />
                    ) : (
                      <div className="config-logo-placeholder">
                        <i className="bi bi-image text-muted" style={{ fontSize: '2rem' }}></i>
                      </div>
                    )}
                    <h6 className="text-white mt-3 mb-1">{formData.nombre_sistema || 'Óptica Inventario'}</h6>
                    <small className="text-white-50">{formData.empresa_nombre || 'Mi Óptica'}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Empresa */}
        {activeTab === 'empresa' && (
          <div className="card fade-in">
            <div className="card-header"><i className="bi bi-building me-2"></i>Datos de la Empresa</div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-8">
                  <label className="form-label">Nombre / Razón Social</label>
                  <input type="text" className="form-control" name="empresa_nombre" value={formData.empresa_nombre || ''} onChange={handleChange} />
                </div>
                <div className="col-md-4">
                  <label className="form-label">RUC / NIT</label>
                  <input type="text" className="form-control" name="empresa_ruc" value={formData.empresa_ruc || ''} onChange={handleChange} />
                </div>
                <div className="col-12">
                  <label className="form-label">Dirección</label>
                  <input type="text" className="form-control" name="empresa_direccion" value={formData.empresa_direccion || ''} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Teléfono</label>
                  <input type="text" className="form-control" name="empresa_telefono" value={formData.empresa_telefono || ''} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" name="empresa_email" value={formData.empresa_email || ''} onChange={handleChange} />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* SRI / Facturacion Electronica */}
        {activeTab === 'sri' && (
          <div className="fade-in">
            {/* Ambiente SRI */}
            <div className="card mb-3">
              <div className="card-header">
                <i className="bi bi-globe me-2"></i>Ambiente SRI
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Ambiente</label>
                    <select className="form-select" name="sri_ambiente" value={formData.sri_ambiente || '1'} onChange={handleChange}>
                      <option value="1">PRUEBAS (Desarrollo)</option>
                      <option value="2">PRODUCCION</option>
                    </select>
                    {formData.sri_ambiente === '2' && (
                      <div className="alert alert-danger mt-2 py-2 small mb-0">
                        <i className="bi bi-exclamation-triangle-fill me-1"></i>
                        <strong>PRODUCCION:</strong> Los comprobantes emitidos son reales y tienen validez tributaria.
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Tipo de Emision</label>
                    <select className="form-select" name="sri_tipo_emision" value={formData.sri_tipo_emision || '1'} onChange={handleChange}>
                      <option value="1">Normal</option>
                    </select>
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-outline-primary w-100"
                      onClick={testConexionSRI}
                      disabled={sriTesting}
                    >
                      {sriTesting ? (
                        <><span className="spinner-border spinner-border-sm me-2"></span>Probando...</>
                      ) : (
                        <><i className="bi bi-wifi me-2"></i>Test Conexion SRI</>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Certificado Digital */}
            <div className="card mb-3">
              <div className="card-header">
                <i className="bi bi-shield-lock me-2"></i>Certificado Digital (.p12)
              </div>
              <div className="card-body">
                {certificadoInfo ? (
                  <div className="alert alert-success mb-3">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <i className="bi bi-check-circle-fill me-2"></i>
                        <strong>Certificado Activo</strong>
                        <div className="small mt-1">
                          <div><strong>Propietario:</strong> {certificadoInfo.propietario || certificadoInfo.nombre}</div>
                          {certificadoInfo.fecha_expiracion && (
                            <div>
                              <strong>Expira:</strong>{' '}
                              {new Date(certificadoInfo.fecha_expiracion).toLocaleDateString('es-EC')}
                              {new Date(certificadoInfo.fecha_expiracion) < new Date() && (
                                <span className="badge bg-danger ms-2">EXPIRADO</span>
                              )}
                              {new Date(certificadoInfo.fecha_expiracion) < new Date(Date.now() + 30*24*60*60*1000) && new Date(certificadoInfo.fecha_expiracion) >= new Date() && (
                                <span className="badge bg-warning ms-2">Por expirar</span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-warning mb-3">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    No hay certificado digital activo. Suba un archivo <strong>.p12</strong> para poder firmar comprobantes.
                  </div>
                )}

                <div className="row g-3">
                  <div className="col-md-5">
                    <label className="form-label fw-bold">1. Contraseña del Certificado</label>
                    <input
                      type="password"
                      className="form-control"
                      value={certPassword}
                      onChange={(e) => setCertPassword(e.target.value)}
                      placeholder="Contraseña del .p12"
                      autoComplete="new-password"
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-bold">2. Archivo .p12 (nuevo certificado)</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".p12,.pfx"
                      onChange={handleCertUpload}
                      disabled={sriUploading}
                    />
                    {sriUploading && (
                      <div className="text-primary mt-1 small">
                        <span className="spinner-border spinner-border-sm me-1"></span>Subiendo y validando...
                      </div>
                    )}
                  </div>
                  <div className="col-md-3 d-flex align-items-end">
                    <button
                      className="btn btn-outline-warning w-100"
                      onClick={handleUpdateCertPassword}
                      disabled={updatingPassword || !certificadoInfo}
                      title={!certificadoInfo ? 'Primero suba un certificado' : 'Actualizar solo la contraseña del certificado existente'}
                    >
                      {updatingPassword ? (
                        <><span className="spinner-border spinner-border-sm me-1"></span>Actualizando...</>
                      ) : (
                        <><i className="bi bi-key me-1"></i>Actualizar Clave</>
                      )}
                    </button>
                  </div>
                </div>
                <div className="alert alert-info mt-3 small mb-0">
                  <i className="bi bi-info-circle me-1"></i>
                  <strong>Dos opciones:</strong>
                  <ul className="mb-0 mt-1">
                    <li><strong>Subir nuevo certificado:</strong> Ingrese la contraseña del .p12 (paso 1) y seleccione el archivo (paso 2). Se reemplazará el certificado actual.</li>
                    <li><strong>Actualizar solo la clave:</strong> Si el certificado actual quedó con una contraseña desalineada, ingrésela en el paso 1 y presione "Actualizar Clave". Se validará contra el .p12 activo antes de guardarla.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Datos del Emisor */}
            <div className="card mb-3">
              <div className="card-header">
                <i className="bi bi-building me-2"></i>Datos del Emisor (Comprobantes)
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Nombre Comercial</label>
                    <input type="text" className="form-control" name="sri_nombre_comercial" value={formData.sri_nombre_comercial || ''} onChange={handleChange} placeholder="Nombre visible en comprobantes" />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Direccion Matriz</label>
                    <input type="text" className="form-control" name="sri_direccion_matriz" value={formData.sri_direccion_matriz || ''} onChange={handleChange} placeholder="Direccion completa de la matriz" />
                    <small className="text-muted">Esta direccion aparece en todos los comprobantes electronicos</small>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Obligado a llevar contabilidad</label>
                    <select className="form-select" name="sri_obligado_contabilidad" value={formData.sri_obligado_contabilidad || 'NO'} onChange={handleChange}>
                      <option value="NO">NO</option>
                      <option value="SI">SI</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Regimen</label>
                    <select className="form-select" name="sri_regimen" value={formData.sri_regimen || 'GENERAL'} onChange={handleChange}>
                      <option value="GENERAL">General</option>
                      <option value="RIMPE">RIMPE - Emprendedor</option>
                      <option value="RIMPE_NEGOCIO_POPULAR">RIMPE - Negocio Popular</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Contribuyente Especial (Nro. Resolucion)</label>
                    <input type="text" className="form-control" name="sri_contribuyente_especial" value={formData.sri_contribuyente_especial || ''} onChange={handleChange} placeholder="Dejar vacio si no aplica" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Agente de Retencion (Nro. Resolucion)</label>
                    <input type="text" className="form-control" name="sri_agente_retencion" value={formData.sri_agente_retencion || ''} onChange={handleChange} placeholder="Dejar vacio si no aplica" />
                  </div>
                </div>
              </div>
            </div>

            {/* Opciones */}
            <div className="card mb-3">
              <div className="card-header">
                <i className="bi bi-sliders me-2"></i>Opciones de Facturacion
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="sri_auto_facturar"
                      name="sri_auto_facturar"
                      checked={formData.sri_auto_facturar || false}
                      onChange={handleChange}
                      style={{ width: '3rem', height: '1.5rem' }}
                    />
                    <label className="form-check-label ms-2" htmlFor="sri_auto_facturar">
                      <strong>Auto-facturar despues de cada venta</strong>
                      <div className="text-muted small">Genera y envia la factura automaticamente al SRI al completar una venta</div>
                    </label>
                  </div>
                </div>
                <div className="mb-0">
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="sri_enviar_email_auto"
                      name="sri_enviar_email_auto"
                      checked={formData.sri_enviar_email_auto || false}
                      onChange={handleChange}
                      style={{ width: '3rem', height: '1.5rem' }}
                    />
                    <label className="form-check-label ms-2" htmlFor="sri_enviar_email_auto">
                      <strong>Enviar comprobante por email automaticamente</strong>
                      <div className="text-muted small">Envia automaticamente el RIDE y XML al email del cliente al autorizar</div>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Configuracion Email SMTP */}
            <div className="card mb-3">
              <div className="card-header">
                <i className="bi bi-envelope me-2"></i>Configuracion Email (SMTP)
              </div>
              <div className="card-body">
                <div className="alert alert-info small mb-3">
                  <i className="bi bi-info-circle me-1"></i>
                  Configure un servidor SMTP para enviar comprobantes electronicos (RIDE + XML) por email a sus clientes.
                  Puede usar Gmail, Outlook, o cualquier servidor SMTP.
                </div>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Servidor SMTP</label>
                    <input type="text" className="form-control" name="smtp_host" value={formData.smtp_host || ''} onChange={handleChange} placeholder="smtp.gmail.com" />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Puerto</label>
                    <input type="number" className="form-control" name="smtp_port" value={formData.smtp_port || '587'} onChange={handleChange} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Seguridad</label>
                    <select className="form-select" name="smtp_secure" value={formData.smtp_secure || 'false'} onChange={handleChange}>
                      <option value="false">STARTTLS</option>
                      <option value="true">SSL/TLS</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Usuario SMTP</label>
                    <input type="text" className="form-control" name="smtp_user" value={formData.smtp_user || ''} onChange={handleChange} placeholder="usuario@gmail.com" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Contrasena SMTP</label>
                    <input type="password" className="form-control" name="smtp_password" value={formData.smtp_password || ''} onChange={handleChange} placeholder="Contrasena o App Password" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Email remitente (From)</label>
                    <input type="email" className="form-control" name="smtp_from" value={formData.smtp_from || ''} onChange={handleChange} placeholder="facturacion@miempresa.com" />
                  </div>
                  <div className="col-md-6 d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-outline-primary w-100"
                      onClick={async () => {
                        try {
                          const res = await facturacionAPI.testEmail();
                          if (res.data.success) {
                            toast.success('Conexion SMTP exitosa');
                          } else {
                            toast.error(res.data.message || 'Error SMTP');
                          }
                        } catch (err) {
                          toast.error(err.response?.data?.message || 'Error al probar SMTP');
                        }
                      }}
                    >
                      <i className="bi bi-envelope-check me-2"></i>Probar Conexion Email
                    </button>
                  </div>
                </div>
                {formData.smtp_host && (
                  <div className="mt-3 p-2 bg-light rounded small">
                    <i className="bi bi-lightbulb text-warning me-1"></i>
                    <strong>Gmail:</strong> Use una "App Password" en vez de su contrasena normal. Vaya a myaccount.google.com &gt; Seguridad &gt; Contrasenas de aplicaciones.
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Pagos */}
        {activeTab === 'pagos' && (
          <div className="fade-in">

            {/* Resumen metodos activos - ARRIBA */}
            <div className="card mb-3 border-primary">
              <div className="card-header bg-primary text-white">
                <i className="bi bi-list-check me-2"></i>Resumen de Metodos de Pago
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-4 col-6">
                    <div className="d-flex align-items-center p-2 rounded bg-success bg-opacity-10 border border-success">
                      <i className="bi bi-cash-stack text-success fs-4 me-2"></i>
                      <div>
                        <div className="fw-bold text-success">Efectivo</div>
                        <small className="text-muted">Siempre activo</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6">
                    <div className="d-flex align-items-center p-2 rounded bg-success bg-opacity-10 border border-success">
                      <i className="bi bi-bank text-success fs-4 me-2"></i>
                      <div>
                        <div className="fw-bold text-success">Transferencia</div>
                        <small className="text-muted">Siempre activo</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6">
                    <div className={`d-flex align-items-center p-2 rounded ${formData.payphone_enabled ? 'bg-success bg-opacity-10 border border-success' : 'bg-light border'}`}>
                      <i className={`bi bi-phone fs-4 me-2 ${formData.payphone_enabled ? 'text-success' : 'text-secondary'}`}></i>
                      <div>
                        <div className={`fw-bold ${formData.payphone_enabled ? 'text-success' : 'text-secondary'}`}>Payphone</div>
                        <small className="text-muted">{formData.payphone_enabled ? (formData.payphone_token ? 'Configurado' : 'Falta token') : 'Desactivado'}</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6">
                    <div className={`d-flex align-items-center p-2 rounded ${formData.medianet_enabled ? 'bg-success bg-opacity-10 border border-success' : 'bg-light border'}`}>
                      <i className={`bi bi-credit-card-2-front fs-4 me-2 ${formData.medianet_enabled ? 'text-success' : 'text-secondary'}`}></i>
                      <div>
                        <div className={`fw-bold ${formData.medianet_enabled ? 'text-success' : 'text-secondary'}`}>Medianet</div>
                        <small className="text-muted">{formData.medianet_enabled ? 'Terminal NEW6260' : 'Desactivado'}</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6">
                    <div className="d-flex align-items-center p-2 rounded bg-info bg-opacity-10 border border-info">
                      <i className="bi bi-clock-history text-info fs-4 me-2"></i>
                      <div>
                        <div className="fw-bold text-info">Credito</div>
                        <small className="text-muted">Hasta {formData.credito_plazo_max || 90} dias</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-6">
                    <div className="d-flex align-items-center p-2 rounded bg-success bg-opacity-10 border border-success">
                      <i className="bi bi-shuffle text-success fs-4 me-2"></i>
                      <div>
                        <div className="fw-bold text-success">Pago Mixto</div>
                        <small className="text-muted">Combinar metodos</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Payphone */}
            <div className="card mb-3">
              <div className="card-header d-flex justify-content-between align-items-center">
                <span><i className="bi bi-phone me-2"></i>Payphone - Pasarela de Pagos Online</span>
                <div className="form-check form-switch mb-0">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="payphone_enabled"
                    name="payphone_enabled"
                    checked={formData.payphone_enabled || false}
                    onChange={handleChange}
                    style={{ width: '3rem', height: '1.5rem' }}
                  />
                  <label className="form-check-label ms-1" htmlFor="payphone_enabled">
                    {formData.payphone_enabled ? <span className="badge bg-success">Activo</span> : <span className="badge bg-secondary">Inactivo</span>}
                  </label>
                </div>
              </div>
              <div className="card-body">
                {!formData.payphone_enabled && (
                  <div className="text-center py-3 text-muted">
                    <i className="bi bi-phone" style={{ fontSize: '2.5rem' }}></i>
                    <p className="mt-2 mb-1">Payphone permite cobrar con tarjeta de credito y debito desde el sistema.</p>
                    <p className="small">Active el switch para configurar la integracion.</p>
                    <div className="mt-2">
                      <a href="https://payphone.app/para-negocios" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-sm me-2">
                        <i className="bi bi-box-arrow-up-right me-1"></i>Registrarse en Payphone
                      </a>
                      <a href="https://www.docs.payphone.app/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary btn-sm">
                        <i className="bi bi-book me-1"></i>Documentacion API
                      </a>
                    </div>
                  </div>
                )}
                {formData.payphone_enabled && (
                  <div>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Ambiente <span className="text-danger">*</span></label>
                        <select className="form-select" name="payphone_ambiente" value={formData.payphone_ambiente || 'test'} onChange={handleChange}>
                          <option value="test">Pruebas (Sandbox)</option>
                          <option value="production">Produccion (Real)</option>
                        </select>
                        {formData.payphone_ambiente === 'production' && (
                          <div className="alert alert-danger mt-2 py-1 px-2 small mb-0">
                            <i className="bi bi-exclamation-triangle-fill me-1"></i><strong>PRODUCCION:</strong> Los cobros seran reales y se descontaran de las tarjetas de los clientes.
                          </div>
                        )}
                        {formData.payphone_ambiente === 'test' && (
                          <div className="text-info small mt-1"><i className="bi bi-info-circle me-1"></i>Modo pruebas: no se realizan cobros reales</div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Store ID <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-shop"></i></span>
                          <input type="text" className="form-control" name="payphone_store_id" value={formData.payphone_store_id || ''} onChange={handleChange} placeholder="Ej: PP-123456" />
                        </div>
                        <small className="text-muted">Se obtiene del <a href="https://appdeveloper.payphonetodoesposible.com/" target="_blank" rel="noopener noreferrer">Portal Developer</a></small>
                      </div>
                      <div className="col-12">
                        <label className="form-label fw-bold">Token de Autenticacion <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-key-fill"></i></span>
                          <input type="password" className="form-control" name="payphone_token" value={formData.payphone_token || ''} onChange={handleChange} placeholder="Bearer token proporcionado por Payphone" />
                        </div>
                        <small className="text-muted">Token de tipo Bearer. Se genera en el Portal Developer de Payphone.</small>
                      </div>
                      <div className="col-12">
                        <label className="form-label fw-bold">URL de Respuesta (Callback)</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-link-45deg"></i></span>
                          <input type="text" className="form-control bg-light" name="payphone_response_url" value={formData.payphone_response_url || ''} onChange={handleChange} />
                        </div>
                        <small className="text-muted">URL a donde Payphone redirige al cliente despues del pago. Configurela tambien en su cuenta de Payphone.</small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Comision Payphone (%)</label>
                        <div className="input-group">
                          <input type="number" step="0.1" min="0" max="100" className="form-control" name="comision_payphone" value={formData.comision_payphone || '0'} onChange={handleChange} />
                          <span className="input-group-text">%</span>
                        </div>
                        <small className="text-muted">Para referencia contable. No afecta el monto cobrado.</small>
                      </div>
                    </div>
                    {/* Status */}
                    <div className={`alert ${formData.payphone_token && formData.payphone_store_id ? 'alert-success' : 'alert-warning'} mt-3 mb-0 py-2`}>
                      {formData.payphone_token && formData.payphone_store_id ? (
                        <><i className="bi bi-check-circle-fill me-2"></i><strong>Payphone configurado.</strong> Los clientes podran pagar con tarjeta desde el punto de venta.</>
                      ) : (
                        <><i className="bi bi-exclamation-triangle-fill me-2"></i><strong>Configuracion incompleta.</strong> Ingrese el Token y Store ID para habilitar los cobros con Payphone.</>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Medianet */}
            <div className="card mb-3">
              <div className="card-header d-flex justify-content-between align-items-center">
                <span><i className="bi bi-credit-card-2-front me-2"></i>Medianet - Terminal de Pago NEW6260</span>
                <div className="form-check form-switch mb-0">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="medianet_enabled"
                    name="medianet_enabled"
                    checked={formData.medianet_enabled || false}
                    onChange={handleChange}
                    style={{ width: '3rem', height: '1.5rem' }}
                  />
                  <label className="form-check-label ms-1" htmlFor="medianet_enabled">
                    {formData.medianet_enabled ? <span className="badge bg-success">Activo</span> : <span className="badge bg-secondary">Inactivo</span>}
                  </label>
                </div>
              </div>
              <div className="card-body">
                {!formData.medianet_enabled && (
                  <div className="text-center py-3 text-muted">
                    <i className="bi bi-credit-card-2-front" style={{ fontSize: '2.5rem' }}></i>
                    <p className="mt-2 mb-1">Registra pagos procesados en terminal Medianet NEW6260.</p>
                    <p className="small">Acepta Visa, Mastercard, American Express, Union Pay y Discover.</p>
                    <p className="small">Active el switch para configurar los datos del terminal.</p>
                    <div className="mt-2">
                      <a href="https://medianet.com.ec" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-sm">
                        <i className="bi bi-box-arrow-up-right me-1"></i>Soporte: 1800-MEDIANET (633426)
                      </a>
                    </div>
                  </div>
                )}
                {formData.medianet_enabled && (
                  <div>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label className="form-label fw-bold">ID del Terminal</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-upc-scan"></i></span>
                          <input type="text" className="form-control" name="medianet_terminal_id" value={formData.medianet_terminal_id || ''} onChange={handleChange} placeholder="Ej: NEW6260-001" />
                        </div>
                        <small className="text-muted">Numero de serie del terminal Medianet NEW6260</small>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Codigo de Comercio</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-building"></i></span>
                          <input type="text" className="form-control" name="medianet_codigo_comercio" value={formData.medianet_codigo_comercio || ''} onChange={handleChange} placeholder="Ej: 1234567890" />
                        </div>
                        <small className="text-muted">Codigo de afiliacion asignado por Medianet</small>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Nombre del Comercio</label>
                        <div className="input-group">
                          <span className="input-group-text"><i className="bi bi-shop-window"></i></span>
                          <input type="text" className="form-control" name="medianet_nombre_comercio" value={formData.medianet_nombre_comercio || ''} onChange={handleChange} placeholder="Nombre registrado en Medianet" />
                        </div>
                        <small className="text-muted">Como aparece en los vouchers del terminal</small>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Comision Medianet (%)</label>
                        <div className="input-group">
                          <input type="number" step="0.1" min="0" max="100" className="form-control" name="comision_medianet" value={formData.comision_medianet || '0'} onChange={handleChange} />
                          <span className="input-group-text">%</span>
                        </div>
                        <small className="text-muted">Porcentaje que cobra Medianet por transaccion. Para referencia contable.</small>
                      </div>
                    </div>
                    {/* Info tarjetas aceptadas */}
                    <div className="alert alert-info mt-3 mb-0 py-2 small">
                      <i className="bi bi-credit-card me-1"></i>
                      <strong>Tarjetas aceptadas:</strong> Visa, Mastercard, American Express, Union Pay, Discover
                      <span className="d-block mt-1">Credito, Debito, Contactless/NFC, Chip EMV, Banda Magnetica</span>
                    </div>
                    {/* Flujo visual */}
                    <div className="card bg-light mt-3">
                      <div className="card-body py-3">
                        <h6 className="card-title mb-3"><i className="bi bi-diagram-3 me-2"></i>Flujo de cobro con terminal Medianet</h6>
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                          <div className="text-center flex-fill">
                            <div className="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center mb-1" style={{ width: '36px', height: '36px', fontSize: '0.9rem' }}><i className="bi bi-cart"></i></div>
                            <div className="small fw-bold">Crear venta</div>
                          </div>
                          <i className="bi bi-chevron-right text-muted"></i>
                          <div className="text-center flex-fill">
                            <div className="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center mb-1" style={{ width: '36px', height: '36px', fontSize: '0.9rem' }}><i className="bi bi-credit-card"></i></div>
                            <div className="small fw-bold">Elegir Medianet</div>
                          </div>
                          <i className="bi bi-chevron-right text-muted"></i>
                          <div className="text-center flex-fill">
                            <div className="rounded-circle bg-warning text-dark d-inline-flex align-items-center justify-content-center mb-1" style={{ width: '36px', height: '36px', fontSize: '0.9rem' }}><i className="bi bi-nfc"></i></div>
                            <div className="small fw-bold">Pasar tarjeta</div>
                          </div>
                          <i className="bi bi-chevron-right text-muted"></i>
                          <div className="text-center flex-fill">
                            <div className="rounded-circle bg-info text-white d-inline-flex align-items-center justify-content-center mb-1" style={{ width: '36px', height: '36px', fontSize: '0.9rem' }}><i className="bi bi-input-cursor-text"></i></div>
                            <div className="small fw-bold">Ingresar codigo</div>
                          </div>
                          <i className="bi bi-chevron-right text-muted"></i>
                          <div className="text-center flex-fill">
                            <div className="rounded-circle bg-success text-white d-inline-flex align-items-center justify-content-center mb-1" style={{ width: '36px', height: '36px', fontSize: '0.9rem' }}><i className="bi bi-check-lg"></i></div>
                            <div className="small fw-bold">Venta registrada</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Credito / Financiamiento */}
            <div className="card mb-3">
              <div className="card-header">
                <i className="bi bi-clock-history me-2"></i>Ventas a Credito
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label fw-bold">Plazo Maximo de Credito</label>
                    <div className="input-group">
                      <input type="number" min="1" max="365" className="form-control" name="credito_plazo_max" value={formData.credito_plazo_max || '90'} onChange={handleChange} />
                      <span className="input-group-text">dias</span>
                    </div>
                    <small className="text-muted">Maximo de dias para pagar una venta a credito</small>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-bold">Comision Transferencia (%)</label>
                    <div className="input-group">
                      <input type="number" step="0.1" min="0" max="100" className="form-control" name="comision_transferencia" value={formData.comision_transferencia || '0'} onChange={handleChange} />
                      <span className="input-group-text">%</span>
                    </div>
                    <small className="text-muted">Comision por transferencia bancaria (referencia contable)</small>
                  </div>
                  <div className="col-md-4 d-flex align-items-start pt-4">
                    <div className="form-check form-switch">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="credito_requiere_aprobacion"
                        name="credito_requiere_aprobacion"
                        checked={formData.credito_requiere_aprobacion || false}
                        onChange={handleChange}
                        style={{ width: '3rem', height: '1.5rem' }}
                      />
                      <label className="form-check-label ms-2" htmlFor="credito_requiere_aprobacion">
                        <strong>Requiere aprobacion</strong>
                        <div className="text-muted small">Solo admin puede aprobar ventas a credito</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tickets / Recibos */}
            <div className="card mb-3">
              <div className="card-header">
                <i className="bi bi-receipt me-2"></i>Tickets / Recibos de Venta
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-bold">Nombre del Negocio</label>
                    <input type="text" className="form-control" name="ticket_nombre_negocio" value={formData.ticket_nombre_negocio || ''} onChange={handleChange} placeholder="OFTALMETRYC" />
                    <small className="text-muted">Aparece en la cabecera del ticket impreso (mayusculas recomendado)</small>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold">RUC del Negocio</label>
                    <input type="text" className="form-control" name="ticket_ruc" value={formData.ticket_ruc || ''} onChange={handleChange} placeholder="1790012345001" />
                    <small className="text-muted">Se muestra debajo del nombre en el ticket</small>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Direccion</label>
                    <input type="text" className="form-control" name="ticket_direccion" value={formData.ticket_direccion || ''} onChange={handleChange} placeholder="Av. Principal y Calle Secundaria" />
                    <small className="text-muted">Direccion que aparece en el ticket</small>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Telefono</label>
                    <input type="text" className="form-control" name="ticket_telefono" value={formData.ticket_telefono || ''} onChange={handleChange} placeholder="(02) 123-4567" />
                    <small className="text-muted">Telefono de contacto en el ticket</small>
                  </div>
                  <div className="col-12">
                    <label className="form-label">Mensaje al Pie del Ticket</label>
                    <input type="text" className="form-control" name="ticket_mensaje_pie" value={formData.ticket_mensaje_pie || ''} onChange={handleChange} placeholder="Gracias por su compra!" />
                    <small className="text-muted">Mensaje personalizado al final del ticket</small>
                  </div>
                  <div className="col-12">
                    <hr className="my-2" />
                    <h6 className="mb-3"><i className="bi bi-sliders me-2"></i>Opciones de Impresion</h6>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check form-switch">
                      <input type="checkbox" className="form-check-input" id="ticket_auto_print" name="ticket_auto_print" checked={formData.ticket_auto_print || false} onChange={handleChange} style={{ width: '3rem', height: '1.5rem' }} />
                      <label className="form-check-label ms-2" htmlFor="ticket_auto_print">
                        <strong>Auto-imprimir</strong>
                        <div className="text-muted small">Imprimir al completar venta</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check form-switch">
                      <input type="checkbox" className="form-check-input" id="ticket_mostrar_iva" name="ticket_mostrar_iva" checked={formData.ticket_mostrar_iva || false} onChange={handleChange} style={{ width: '3rem', height: '1.5rem' }} />
                      <label className="form-check-label ms-2" htmlFor="ticket_mostrar_iva">
                        <strong>Mostrar IVA</strong>
                        <div className="text-muted small">Desglosar IVA en el ticket</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check form-switch">
                      <input type="checkbox" className="form-check-input" id="ticket_mostrar_cliente" name="ticket_mostrar_cliente" checked={formData.ticket_mostrar_cliente || false} onChange={handleChange} style={{ width: '3rem', height: '1.5rem' }} />
                      <label className="form-check-label ms-2" htmlFor="ticket_mostrar_cliente">
                        <strong>Datos del cliente</strong>
                        <div className="text-muted small">Nombre y CI/RUC en ticket</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-check form-switch">
                      <input type="checkbox" className="form-check-input" id="ticket_mostrar_logo" name="ticket_mostrar_logo" checked={formData.ticket_mostrar_logo || false} onChange={handleChange} style={{ width: '3rem', height: '1.5rem' }} />
                      <label className="form-check-label ms-2" htmlFor="ticket_mostrar_logo">
                        <strong>Logo en ticket</strong>
                        <div className="text-muted small">Mostrar logo en B/N en el ticket</div>
                      </label>
                    </div>
                  </div>
                  {formData.ticket_mostrar_logo && (
                    <div className="col-md-6">
                      <label className="form-label fw-bold">
                        Ancho del Logo: {formData.ticket_logo_ancho || 120}px
                      </label>
                      <input
                        type="range"
                        className="form-range"
                        name="ticket_logo_ancho"
                        min="40"
                        max="250"
                        step="10"
                        value={formData.ticket_logo_ancho || 120}
                        onChange={handleChange}
                      />
                      <div className="d-flex justify-content-between">
                        <small className="text-muted">40px</small>
                        <small className="text-muted">Pequeno</small>
                        <small className="text-muted">Mediano</small>
                        <small className="text-muted">Grande</small>
                        <small className="text-muted">250px</small>
                      </div>
                    </div>
                  )}
                </div>

                {/* Vista previa mini del ticket */}
                <div className="mt-3">
                  <h6 className="mb-2"><i className="bi bi-eye me-2"></i>Vista Previa del Ticket</h6>
                  <div className="mx-auto border rounded p-3" style={{ maxWidth: '300px', fontFamily: 'monospace', fontSize: '11px', background: '#fefefe' }}>
                    <div className="text-center border-bottom pb-2 mb-2">
                      {formData.ticket_mostrar_logo && logoUrl && (
                        <div className="mb-1">
                          <img src={logoUrl} alt="Logo" style={{ maxWidth: Math.min(parseInt(formData.ticket_logo_ancho) || 120, 200) * 0.65, objectFit: 'contain', filter: 'grayscale(100%) contrast(1.2)' }} />
                        </div>
                      )}
                      <strong style={{ fontSize: '13px' }}>{formData.ticket_nombre_negocio || 'NOMBRE DEL NEGOCIO'}</strong>
                      {formData.ticket_ruc && <div>RUC: {formData.ticket_ruc}</div>}
                      {formData.ticket_direccion && <div>{formData.ticket_direccion}</div>}
                      {formData.ticket_telefono && <div>Tel: {formData.ticket_telefono}</div>}
                    </div>
                    <div className="border-bottom pb-1 mb-1">
                      <div className="d-flex justify-content-between"><span>Factura:</span><span>001-001-000001234</span></div>
                      <div className="d-flex justify-content-between"><span>Fecha:</span><span>{new Date().toLocaleDateString('es-EC')}</span></div>
                      {formData.ticket_mostrar_cliente && <div className="d-flex justify-content-between"><span>Cliente:</span><span>Juan Perez</span></div>}
                    </div>
                    <div className="border-bottom pb-1 mb-1">
                      <div className="d-flex justify-content-between"><span>1x Lente Progresivo</span><span>$85.00</span></div>
                      <div className="d-flex justify-content-between"><span>1x Montura Ray-Ban</span><span>$120.00</span></div>
                    </div>
                    <div className="border-bottom pb-1 mb-1">
                      {formData.ticket_mostrar_iva && <><div className="d-flex justify-content-between"><span>Subtotal:</span><span>$178.26</span></div><div className="d-flex justify-content-between"><span>IVA 15%:</span><span>$26.74</span></div></>}
                      <div className="d-flex justify-content-between"><strong>TOTAL:</strong><strong>$205.00</strong></div>
                    </div>
                    <div className="text-center mt-2" style={{ fontSize: '10px' }}>
                      {formData.ticket_mensaje_pie || 'Gracias por su compra!'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Inteligencia Artificial */}
        {activeTab === 'ia' && (
          <div className="card fade-in">
            <div className="card-header"><i className="bi bi-robot me-2"></i>Asistente de Inteligencia Artificial</div>
            <div className="card-body">
              <div className="alert alert-info mb-4">
                <i className="bi bi-info-circle me-2"></i>
                El asistente de IA te ayuda a navegar el sistema, explica cómo usar cada módulo y responde preguntas sobre el inventario.
                Usa <strong>OpenRouter</strong> para conectar con modelos de OpenAI, Anthropic, Google y más.
              </div>

              <div className="mb-4">
                <div className="form-check form-switch">
                  <input 
                    type="checkbox" 
                    className="form-check-input" 
                    id="ai_enabled" 
                    name="ai_enabled" 
                    checked={formData.ai_enabled || false} 
                    onChange={handleChange}
                    style={{ width: '3rem', height: '1.5rem' }}
                  />
                  <label className="form-check-label ms-2" htmlFor="ai_enabled">
                    <strong>Activar Asistente de IA</strong>
                  </label>
                </div>
              </div>

              {formData.ai_enabled && (
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">API Key de OpenRouter</label>
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-key"></i></span>
                      <input 
                        type="password" 
                        className="form-control" 
                        name="ai_api_key" 
                        value={formData.ai_api_key || ''} 
                        onChange={handleChange}
                        placeholder="sk-or-..."
                      />
                    </div>
                    <small className="text-muted">
                      Obtén tu API Key en <a href="https://openrouter.ai/keys" target="_blank" rel="noopener noreferrer">openrouter.ai/keys</a>
                    </small>
                  </div>

                  <div className="col-md-8">
                    <label className="form-label">Modelo de IA</label>
                    <select className="form-select" name="ai_model" value={formData.ai_model || ''} onChange={handleChange}>
                      <optgroup label="OpenAI">
                        {AI_MODELS.filter(m => m.provider === 'OpenAI').map(m => (
                          <option key={m.value} value={m.value}>{m.label}</option>
                        ))}
                      </optgroup>
                      <optgroup label="Anthropic">
                        {AI_MODELS.filter(m => m.provider === 'Anthropic').map(m => (
                          <option key={m.value} value={m.value}>{m.label}</option>
                        ))}
                      </optgroup>
                      <optgroup label="Google">
                        {AI_MODELS.filter(m => m.provider === 'Google').map(m => (
                          <option key={m.value} value={m.value}>{m.label}</option>
                        ))}
                      </optgroup>
                      <optgroup label="Otros">
                        {AI_MODELS.filter(m => !['OpenAI', 'Anthropic', 'Google'].includes(m.provider)).map(m => (
                          <option key={m.value} value={m.value}>{m.label}</option>
                        ))}
                      </optgroup>
                    </select>
                  </div>

                  <div className="col-md-4 d-flex align-items-end">
                    <button 
                      type="button" 
                      className="btn btn-outline-primary w-100"
                      onClick={testAIConnection}
                      disabled={testingAI || !formData.ai_api_key}
                    >
                      {testingAI ? (
                        <><span className="spinner-border spinner-border-sm me-2"></span>Probando...</>
                      ) : (
                        <><i className="bi bi-lightning me-2"></i>Probar Conexión</>
                      )}
                    </button>
                  </div>

                  <div className="col-12">
                    <div className="card bg-light">
                      <div className="card-body">
                        <h6 className="card-title"><i className="bi bi-lightbulb me-2"></i>¿Qué puede hacer el asistente?</h6>
                        <ul className="mb-0 small">
                          <li><strong>Navegar:</strong> "Llévame a productos", "Ir a compras"</li>
                          <li><strong>Guiar:</strong> "¿Cómo registro una compra?", "¿Cómo ajusto el stock?"</li>
                          <li><strong>Explicar:</strong> "¿Qué es el Kardex?", "¿Para qué sirve el stock mínimo?"</li>
                          <li><strong>Ayudar:</strong> "¿Qué puedo hacer aquí?", "Ayuda"</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Botón Guardar */}
        <div className="mt-4">
          <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
            {loading ? (
              <><span className="spinner-border spinner-border-sm me-2"></span>Guardando...</>
            ) : (
              <><i className="bi bi-check-lg me-2"></i>Guardar Configuración</>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Configuracion;
